export default {
  emailAddresses: [],
};
